/// <amd-module name="TFS/Admin/Groups/Pivots/Settings/Components/SettingsPivot" />
import * as React from "react";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { IPivotProps } from "TFS/Admin/Groups/Common/Contracts";
import { ConnectedSettingsPivotInitializer } from "TFS/Admin/Groups/Pivots/Settings/Components/SettingsPivotInitializer";
import { getSettingsPivotModule } from "TFS/Admin/Groups/Pivots/Settings/Redux/SettingsPivotModule";
import { DynamicModuleLoader } from "redux-dynamic-modules";

export class SettingsPivot extends VssComponent<IPivotProps> {
    constructor(props: IPivotProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): JSX.Element {
        return (
            <DynamicModuleLoader modules={[getSettingsPivotModule()]}>
                <ConnectedSettingsPivotInitializer pageContext={this.context.pageContext} />
            </DynamicModuleLoader>
        );
    }
}

VssComponent.register("ms.vss-admin-web.orggroups-settings-pivot", SettingsPivot);
